import { PublicKey } from '@solana/web3.js';

/**
 * Mavrk Platform Fee Wallet
 * This is where LP position NFTs are sent for protocol custody
 * 
 * Note: In production, consider fetching this from an environment variable
 * or API endpoint to make it harder to discover
 */
export const MAVRK_PLATFORM_FEE_WALLET = new PublicKey(
  process.env.NEXT_PUBLIC_MAVRK_FEE_WALLET || '9ES5tk9krojWPwLvXmpsrbHZ1ggeq4ZHEqkyAgdf2WSF'
);

